import { useState } from 'react'
import { Link } from 'react-router-dom'
import OverlayNonSiOhhh from '../../overlay/presentational/OverlayNonSiOhhh';
import config from '../../../config.json'
import getEventValue from '../func/getEventValue';
import getStatusName from '../func/getStatusName'
import TranslationTime from '../../Translation/cont/TranslationTime';
import getEventTypeName from '../func/getEventTypeName';

const SortableEventsListItem = ({event, eventSettings, sortSettings, gridColumnsStyle, canDeleteEvent, onDeleteEvent }) => {
    const [displayDeleteOverlay, setDisplayDeleteOverlay] = useState(false);

    const { id, settings_id } = event
    const path =  `${config.routes.events.path}/${id}/${settings_id}`
    const onlyNameIfNecessary = sortSettings.hasOwnProperty('name') && sortSettings.hasOwnProperty('request_id')

    const deleteEvent = () => {
        onDeleteEvent(id);
        setDisplayDeleteOverlay(false);
    }

    return (
        <>
            <li className="event-item">
                <div className="event-item-col even">
                    <Link className="button icon button-edit button-edit-event" to={path}>
                        <span className="screen-reader-text">Edit Event</span>
                    </Link>
                </div>

                <div className="event-item-col odd">
                    <button 
                        className="button icon button-delete button-delete-event" 
                        onClick={()=>setDisplayDeleteOverlay(true)}
                        disabled={!canDeleteEvent}
                    >
                        <span className="screen-reader-text">Delete Event</span>
                    </button>
                </div>

                <div className="event-item-col even">
                    <Link className="sortable-events-data title text-light" to={path} style={gridColumnsStyle}>
                        {Object.keys(sortSettings).map(settingId => {
                            const settings = sortSettings[settingId]
                            let value = getEventValue(settingId, event)

                            if('status' === settingId) {
                                value = getStatusName(value)
                            }
                            else if('event_types' === settingId) {
                                value = getEventTypeName(value, eventSettings)       
                            }                    

                            else if(onlyNameIfNecessary && 'name' === settingId) {
                                value = value === getEventValue('request_id', event) ? '' : value
                            }

                            let valuePresent = ''

                            if('string' === settings.type) {
                                valuePresent = value
                            } else if('date' === settings.type) {
                                valuePresent = <TranslationTime id="date" timeString={value}/>
                            }

                            return <span key={settingId} className={settingId}>{valuePresent}</span>
                        })}
                    </Link>
                </div>
            </li>

            {canDeleteEvent && displayDeleteOverlay && <OverlayNonSiOhhh
                titleTransId={'overlay_delete_event_title'}
                text=""
                nonButtonTextTransId="cancel_button"
                nonOnClickButton={() => setDisplayDeleteOverlay(false)}
                siButtonTextTransId='remove_button'
                siOnClickButton={deleteEvent}
            />}
        </>
    )
}

export default SortableEventsListItem

